import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const VolumeMute = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='VolumeMute' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M1,8 L1,16 L6.09901951,16 L12,21 L12,3 L6,8 L1,8 Z M15,9 L21,15 M21,9 L15,15' />
  </StyledIcon>
);
